import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
import { LOADING_TEXT } from "../../constants";
import skeletonStyles from "../skeleton.module.css";
import styles from "./subtitle.module.css";
export var Subtitle = function(param) {
    var children = param.children, _isPending = param.isPending, isPending = _isPending === void 0 ? false : _isPending, _className = param.className, className = _className === void 0 ? "" : _className, fontSize = param.fontSize;
    var _obj;
    return /*#__PURE__*/ _jsx(Text, {
        fontSizeFixed: fontSize || "xs",
        className: cx(className, styles.subtitle, (_obj = {}, _define_property(_obj, skeletonStyles.base, isPending), _define_property(_obj, skeletonStyles.active, isPending), _obj)),
        children: isPending ? LOADING_TEXT : children
    });
};
export default Subtitle;
